import i18nextConfig from '../../next-i18next.config'

const enrichedLocales = i18nextConfig.i18n.locales
const localeCodes = enrichedLocales

export function getCleanPath(asPath: string): string {
  const localePattern = new RegExp(`^/(${localeCodes.join('|')})(/|$)`)
  const cleaned = asPath.replace(localePattern, '/')

  return cleaned !== '/' ? cleaned.replace(/\/+$/, '') : cleaned
}
